import { type HeaderGroup } from '@tanstack/react-table';
import React, { memo, type PropsWithChildren } from 'react';
import isEqual from 'react-fast-compare';
import { Box } from '../../../../Box';
import { dataTableClassnames } from '../../const/classNames';
import { internalColumnTypes } from '../../const/internalColumnType';
import { CellResizer } from './cells/CellResizer';

interface HeaderRowsProps {
  headerGroups: HeaderGroup<any>[];
  resize: boolean;
  tableBodyHeight?: number;
}

export const HeaderRows: React.FC<HeaderRowsProps> = ({ headerGroups, resize, tableBodyHeight }) => {
  return headerGroups.map((headerGroup) => (
    <Box
      key={headerGroup.id}
      role="row"
      className={`${dataTableClassnames.table.row.root} ${dataTableClassnames.table.row.head}`}
    >
      {headerGroup.headers.map((header) => {
        return (
          <Box
            className={`${dataTableClassnames.table.cell.root} ${dataTableClassnames.table.cell.head} ${dataTableClassnames.table.cell.field(header.id)}`}
            key={header.id}
            style={{
              width: header.getSize()
            }}
            role="columnheader"
          >
            {header.isPlaceholder ? null : (
              <HeaderCell>
                {typeof header.column.columnDef.header === 'string'
                  ? header.column.columnDef.header
                  : header.column.columnDef.header?.(header.getContext())}
              </HeaderCell>
            )}
            {!internalColumnTypes.includes(header.id) && resize && header.column.columnDef.enableResizing && (
              <CellResizer header={header} tableBodyHeight={tableBodyHeight} />
            )}
          </Box>
        );
      })}
    </Box>
  ));
};

const HeaderCell = memo(
  (props: PropsWithChildren) => {
    return props.children;
  },
  (prevProps, nextProps) => {
    const { children: _cp, ...prev } = prevProps;
    const { children: _cn, ...next } = nextProps;
    const childrenLvl0 = isEqual((_cp ?? ({} as any)).props, (_cn ?? ({} as any)).props);
    return isEqual(prev, next) && childrenLvl0;
  }
);
